module.exports = __webpack_public_path__ + "static/opened-envelope-429a6dec3bde3750f3bfe8fcfb23e249.svg";